// extracted by mini-css-extract-plugin
module.exports = {"imageLevelResultTag":"index_imageLevelResultTag__35wTs"};